export default __webpack_public_path__ + "static/logonav-756841f843be104571f7f3280e1b71a7.png";